export default __webpack_public_path__ + "static/media/filterIcon.7946696d.svg";